// İş Takip listesi ve detay sayfasının paylaştığı yardımcılar.
//
// Bunlar eskiden WorkTasks.jsx içinde tanımlıydı; detay sayfası eklenince iki
// yerde birden gerektiği için buraya alındı. Kopyalanmış olsalardı zamanla
// birbirinden sapardı (ör. yeni bir olay türü sadece bir tarafa eklenirdi).

export const ATTACHMENT_ACCEPT =
  '.jpg,.jpeg,.png,.webp,.heic,.pdf,image/jpeg,image/png,image/webp,image/heic,application/pdf';

export const formatBytes = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const isImageAttachment = (name) => /\.(jpe?g|png|webp|heic)$/i.test(name || '');

/**
 * Devir/not/dosya/tamamlanma olaylarını tek, kronolojik bir akışta birleştirir —
 * "kim, ne zaman, ne yaptı" sorusuna tek bir yerden cevap vermek için.
 */
export const buildTimeline = (item) => {
  const events = [];

  (item?.handoffs || []).forEach((h) => {
    events.push({
      id: `handoff-${h.id}`,
      date: h.created_at,
      kind: h.from_user ? 'handoff' : 'assigned',
      actor: h.from_user ? `${h.from_user.name} ${h.from_user.surname}` : null,
      target: h.to_user ? `${h.to_user.name} ${h.to_user.surname}` : null,
      note: h.note,
    });
  });

  (item?.notes || []).forEach((n) => {
    events.push({
      id: `note-${n.id}`,
      date: n.created_at,
      kind: 'note',
      actor: n.author ? `${n.author.name} ${n.author.surname}` : null,
      note: n.note,
    });
  });

  (item?.attachments || []).forEach((a) => {
    events.push({
      id: `attachment-${a.id}`,
      date: a.created_at,
      kind: 'attachment',
      actor: a.uploader ? `${a.uploader.name} ${a.uploader.surname}` : null,
      attachment: a,
    });
  });

  // Çoklu kişi atamasında (#30) tamamlanma artık görev değil, her atananın
  // kendi satırı seviyesinde - o yüzden her tamamlayan için ayrı bir olay.
  (item?.assignees || []).forEach((a) => {
    if (a.is_completed && a.completed_at) {
      events.push({
        id: `completed-${a.id}`,
        date: a.completed_at,
        kind: 'completed',
        actor: a.user ? `${a.user.name} ${a.user.surname}` : null,
        note: a.completion_note,
      });
    }
  });

  return events.sort((a, b) => new Date(a.date) - new Date(b.date));
};

/**
 * Kullanıcının rolüne göre iş detayı rotası.
 *
 * Stajyerin ekranları `/intern` altında ayrı bir Route ağacında; aynı
 * WorkTasks/WorkTaskDetail bileşenleri hem `/work-tasks` hem
 * `/intern/work-tasks` yollarına bağlı. Liste satırından MUTLAK
 * `/work-tasks/:id` yoluna gidilince stajyer `StaffRoute`'a düşüyor ve
 * `/intern/today`'e ATILIYORDU — kullanıcının bildirdiği "detaya giremiyor,
 * ana sayfaya atıyor" hatası buydu.
 *
 * Mobil tarafta aynı yardımcı zaten vardı (`src/utils/workTask.js` →
 * `workTaskDetailPath`), web'de yoktu.
 */
export const workTaskDetailPath = (role, id) => {
  const prefix = role === 'stajyer' ? '/intern' : '';
  return id ? `${prefix}/work-tasks/${id}` : `${prefix}/work-tasks`;
};
